import environment from '../../../environment';
import { notifyError } from '../../../shared';
import fetch from '../../fetch';
import reducers from './reducers';

const report = (() => {
    const get = {
        filters (id) {
            return fetch({
                type: 'GET',
                url: `${environment.get('API_HOST')}/import/GetReportFilters/`,
                data: {
                    reportId: id
                }
            }).then(reducers.filters, notifyError);
        },

        files (id, date) {
            return fetch({
                type: 'POST',
                url: `${environment.get('API_HOST')}/import/GetFileToDownload/`,
                data: JSON.stringify({
                    reportId: id,
                    referenceDate: date
                }),
                dataType: 'binary'
            });
        }
    };

    return {
        get
    };
})();

export default report;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/report/index.js